'use strict';
(() => {
  if (window.jwTapestryV2Booted) return;
  window.jwTapestryV2Booted = true;
  function initialize(root) {
    if (root.dataset.ready === 'true') return;
    const configElement = root.querySelector('[data-jwv2-config]');
    if (!configElement) return;
    const config = JSON.parse(configElement.textContent);
    const media = config.media;
    const $ = selector => root.querySelector(selector);
    const $$ = selector => [...root.querySelectorAll(selector)];
    root.dataset.ready = 'true';
  const mainImage = $('#jwv2-main-image');
  $$('.jwv2-thumb').forEach(button => button.addEventListener('click', () => {
    if (!mainImage) return;
    mainImage.src = button.dataset.displaySrc || button.dataset.src;
    mainImage.srcset = button.dataset.srcset || '';
    mainImage.dataset.fullSrc = button.dataset.src;
    mainImage.alt = button.dataset.alt;
    $$('.jwv2-thumb').forEach(b => {
      const active = b === button;
      b.classList.toggle('jwv2-active', active);
      b.setAttribute('aria-pressed', String(active));
    });
  }));
  const dialog = $('#jwv2-media-dialog');
  const dialogImage = $('#jwv2-dialog-image');
  const video = $('#jwv2-dialog-video');
  let lastFocus = null;
  let previousOverflow = '';
  const openDialog = () => {
    lastFocus = document.activeElement;
    dialog.showModal();
    previousOverflow = document.body.style.overflow;
    document.body.style.overflow = 'hidden';
    $('.jwv2-close-dialog').focus();
  };
  const showImage = (src, caption) => {
    video.pause(); video.hidden = true;
    dialogImage.src = src; dialogImage.alt = caption; dialogImage.hidden = false;
    $('#jwv2-media-caption').textContent = caption;
    openDialog();
  };
  $('#jwv2-enlarge-main')?.addEventListener('click', () => showImage(mainImage.dataset.fullSrc || mainImage.src, mainImage.alt));
  $('#jwv2-zoom-button')?.addEventListener('click', () => showImage(mainImage.dataset.fullSrc || mainImage.src, mainImage.alt));
  $$('[data-enlarge]').forEach(b => b.addEventListener('click', () => showImage(b.dataset.enlarge, b.dataset.caption)));
  $$('[data-video]').forEach(b => b.addEventListener('click', () => {
    dialogImage.hidden = true; video.hidden = false;
    $('#jwv2-media-caption').textContent = 'Actual woven sample · 18-second close-up';
    openDialog();
    video.play().catch(() => {  });
  }));
  $('.jwv2-close-dialog').addEventListener('click', () => dialog.close());
  dialog.addEventListener('click', event => {
    if (event.target !== dialog) return;
    const rect = dialog.getBoundingClientRect();
    if (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom) dialog.close();
  });
  dialog.addEventListener('close', () => {
    video.pause(); document.body.style.overflow = previousOverflow;
    if (lastFocus && lastFocus.isConnected) lastFocus.focus();
  });
  if ($('#jwv2-presentation-regions')) {
  const sampleStudies = config.samples;
  let sampleKey = 'strawberry';
  let sampleRegion = sampleStudies[sampleKey].default_region;
  const presentationNotes = {
    strawberry: 'Fine petal lines and strawberry seeds remain distinct, while yarn changes the colour and surface.',
    mural: 'Follow the faces, flowing garments and temple columns as painted detail takes shape in yarn.'
  };
  function showPresentation() {
    const config = sampleStudies[sampleKey];
    const dpi = $('#jwv2-presentation-dpi').value;
    const colours = $('#jwv2-presentation-colours').value;
    const base = `assets/presentation-studies/${sampleKey}-${sampleRegion}`;
    const images = {
      original: [`${base}-original.webp`, 'original artwork'],
      coarse: [`${base}-12-${colours}.webp`, `12 DPI simulation with ${colours} colours`],
      model: [`${base}-${dpi}-${colours}.webp`, `${dpi} DPI simulation with ${colours} colours`],
      actual: [`${base}-actual.webp`, 'actual woven sample photograph, geometrically aligned']
    };
    Object.entries(images).forEach(([name,[src,description]]) => {
      const image = $(`#jwv2-preview-${name}`);
      image.src = media[src];
      image.alt = `${config.title}, ${config.regions[sampleRegion]}: ${description}`;
    });
    $('#jwv2-preview-dpi-value').textContent = dpi;
    $('#jwv2-preview-coarse-note').textContent = `${colours}-colour digital preview`;
    $('#jwv2-preview-model-note').textContent = `${colours}-colour digital preview`;
    $('#jwv2-preview-observation').textContent = presentationNotes[sampleKey];
    $('#jwv2-presentation-download').href = media[`${base}-comparison.jpg`];
    $('#jwv2-presentation-download').download = `${sampleKey}-${sampleRegion}-${config.default_colours}-colour-study.jpg`;
    $('#jwv2-presentation-download').textContent = `Download ${config.default_colours}-colour study ↓`;
    $('#jwv2-presentation-download').setAttribute('aria-label', `Download ${config.default_dpi} DPI / ${config.default_colours}-colour sample study`);
    $$('.jwv2-detail-choice').forEach(button => {
      const active = button.dataset.region === sampleRegion;
      button.classList.toggle('jwv2-active',active);
      button.setAttribute('aria-pressed',String(active));
    });
  }
  function chooseSample(key) {
    sampleKey = key;
    const config = sampleStudies[key];
    sampleRegion = config.default_region;
    $('#jwv2-presentation-dpi').value = String(config.default_dpi);
    $('#jwv2-presentation-colours').value = String(config.default_colours);
    $('#jwv2-presentation-regions').replaceChildren(...Object.entries(config.regions).map(([region,label]) => {
      const button = document.createElement('button');
      button.type = 'button'; button.className = 'jwv2-detail-choice';
      button.dataset.region = region; button.textContent = label;
      return button;
    }));
    $$('.jwv2-sample-choice').forEach(button => {
      const active = button.dataset.sample === key;
      button.classList.toggle('jwv2-active',active);
      button.setAttribute('aria-pressed',String(active));
    });
    showPresentation();
  }
  $$('.jwv2-sample-choice').forEach(button => button.addEventListener('click',() => chooseSample(button.dataset.sample)));
  $('#jwv2-presentation-regions').addEventListener('click',event => {
    const button = event.target.closest('[data-region]');
    if (!button) return;
    sampleRegion = button.dataset.region;
    showPresentation();
  });
  ['#jwv2-presentation-dpi','#jwv2-presentation-colours'].forEach(id => $(id).addEventListener('change',showPresentation));
  chooseSample(sampleKey);
  }

  const studies = {
    'colour-detail-v3': {
      alt: 'AI colour and fine-detail chart beside a woven simulation, with a swatch matrix, horizontal gradients, arcs, chevrons and dots; not a physical test',
      note: 'Explore how colour steps, gradients, fine strokes and dots can take shape in a woven surface.',
      label: 'colour and fine detail'
    },
    'rhythm-geometry': {
      file: 'rhythm-geometry-v2',
      alt: 'Original AI composition of curved ribbons, colour blocks and stepped edges beside a hypothetical jacquard interpretation',
      note: 'Follow the curves, colour blocks and narrow cream line through this woven interpretation.',
      label: 'curves and colour blocks'
    },
    'still-life-tones': {
      file: 'still-life-tones-v2',
      alt: 'Original AI still life of a pear, ivory ceramic vase and blue fabric beside a hypothetical woven interpretation of its light and shade',
      note: 'Look at the pear’s rounded shading, the vase highlight and the blue cloth folds as they translate into a woven surface.',
      label: 'still-life light and tone'
    }
  };
  $('#jwv2-study-full')?.addEventListener('click', () => {
    const image = $('#jwv2-study-image');
    showImage(image.src, image.alt);
  });
  $$('.jwv2-study-choice').forEach(button => button.addEventListener('click', () => {
    const key = button.dataset.study;
    const study = studies[key];
    const src = media[`assets/simulations/${study.file || key}.png`];
    $('#jwv2-study-image').src = src;
    $('#jwv2-study-image').alt = study.alt;
    $('#jwv2-study-note').textContent = study.note;
    $('#jwv2-study-full').setAttribute('aria-label', `Enlarge ${study.label} simulation`);
    $('#jwv2-study-download').href = src;
    $$('.jwv2-study-choice').forEach(choice => {
      const active = choice === button;
      choice.classList.toggle('jwv2-active', active);
      choice.setAttribute('aria-pressed', String(active));
    });
  }));

  $('#jwv2-whatsapp-draft')?.addEventListener('submit', event => {
    event.preventDefault();
    const values = new FormData(event.currentTarget);
    const lines = ['Hello Jacquard Works, I would like to discuss a custom jacquard project.'];
    const labels = {name:'Name / company',use:'Intended use',size:'Target size',quantity:'Estimated quantity',brief:'Design notes'};
    Object.keys(labels).forEach(key => {
      const value = String(values.get(key) || '').trim();
      if (value) lines.push(`${labels[key]}: ${value}`);
    });
    lines.push('I can share my artwork here. Please advise on sampling and a quotation.');
    const url = `https://wa.me/${String(config.whatsapp || '8617367378550').replace(/\D/g, '')}?text=${encodeURIComponent(lines.join('\n'))}`;
    const status = $('#jwv2-form-status');
    status.replaceChildren(document.createTextNode('Your WhatsApp draft is ready. '));
    const link = document.createElement('a');
    link.href = url; link.target = '_blank'; link.rel = 'noopener noreferrer';
    link.textContent = 'Open the draft again ↗';
    status.append(link);
    window.sendCtaEvent?.('whatsapp', 'tapestry_v2_rfq', 'WhatsApp RFQ', url.split('?')[0]);
    window.open(url, '_blank', 'noopener,noreferrer');
  });

  }
  function boot(scope) {
    if (scope.matches?.('.jw-tapestry-v2')) initialize(scope);
    scope.querySelectorAll('.jw-tapestry-v2').forEach(initialize);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => boot(document), {once: true});
  else boot(document);
  document.addEventListener('shopify:section:load', event => boot(event.target));
})();
